export default __webpack_public_path__ + "static/kb_3_20-b8ebfc4e618938118b4499530a0e316a.jpg";